import { Checkbox, FormControlLabel, Stack } from '@mui/material';
import { statusOptions } from '../opportunities/list/useOpportunityFilters';
import { FC } from 'react';

type StatusCheckListProps = Readonly<{
	value: readonly string[];
	onChange(newStatuses: readonly string[]): void;
}>;

export const StatusCheckList: FC<StatusCheckListProps> = ({ value, onChange }) => {
	const statuses = statusOptions;
	const selectedStatuses = value.filter((id) => statuses.some((statusId) => statusId === id));

	return (
		<Stack direction={'column'}>
			{statuses.map((tag) => (
				<FormControlLabel
					label={tag[0].toUpperCase() + tag.slice(1)}
					control={
						<Checkbox
							id={tag}
							name={tag}
							value={value}
							onChange={() =>
								selectedStatuses.includes(tag)
									? onChange(selectedStatuses.filter((status) => status !== tag))
									: onChange(selectedStatuses.concat(tag))
							}
							checked={selectedStatuses.includes(tag)}
						/>
					}
				/>
			))}
		</Stack>
	);
};
